import { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useFamilyStore } from '@/store/familyStore';
import { AddChildRequestData, AddInfoRequestData } from '../types/request';
import { api } from '@/lib/api/client';

export function useUserRequests() {
  const user = useAuthStore(state => state.user);
  const { requests = [], personalInfoRequests = [] } = useFamilyStore();

  const handleAddChildRequest = async (data: AddChildRequestData) => {
    if (!user) return;
    
    try {
      await api.post('api/requests', {
        type: 'add_child',
        ...data
      });
      
      // Refresh requests after submission
      await useFamilyStore.getState().fetchRequests();
    } catch (error) {
      console.error('Error submitting child request:', error);
      throw error;
    }
  };

  const handleAddInfoRequest = async (data: AddInfoRequestData) => {
    if (!user) return;
    
    try {
      await api.post('api/requests', {
        type: 'info',
        personalInfo: data,
        phoneNumber: user.phoneNumber
      });

      // Refresh requests after submission
      await useFamilyStore.getState().fetchRequests();
    } catch (error) {
      console.error('Error submitting info request:', error);
      throw error;
    }
  };

  return {
    requests: [...requests, ...personalInfoRequests].sort((a, b) => 
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    ),
    handleAddChildRequest,
    handleAddInfoRequest
  };
}